import { trackEvent, incrementTimeSpent } from '../mixpanel';

export const trackPageOncePerDay = (page, user) => {
  const todayIST = new Date().toLocaleString("en-US", {
    timeZone: "Asia/Kolkata",
  });
  const today = new Date(todayIST).toISOString().slice(0, 10);
  const key = `daily_page_views_${user.id}`;
  const trackedPages = JSON.parse(localStorage.getItem(key)) || {};

  if (trackedPages[page] !== today) {
    trackEvent('Daily Page Visit', {
      page,
      date: today,
      name: user.name,
      email: user.email,
    });

    trackedPages[page] = today;
    localStorage.setItem(key, JSON.stringify(trackedPages));
  }
};

export const startUserSession = (user) => {
  const now = new Date();
  localStorage.setItem(`session_start_${user.id}`, now.toISOString());
  const istTime = now.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
  trackEvent('Session Start', {
    start_time: istTime,
    name: user.name,
    email: user.email,
  });
};

export const endUserSession = (user) => {
  const endDate = new Date();
  const startTimeISO = localStorage.getItem(`session_start_${user?.id || "guest"}`);
  localStorage.removeItem(`session_start_${user?.id || "guest"}`);
  if (startTimeISO) {
    const startDate = new Date(startTimeISO);
    const durationMs = endDate.getTime() - startDate.getTime();
    const durationSeconds = Math.floor(durationMs / 1000);
    const durationMinutes = Math.floor(durationMs / (1000 * 60));
    const startIST = startDate.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
    const endIST = endDate.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
    trackEvent('Session End', {
      start_time: startIST,
      end_time: endIST,
      duration_seconds: durationSeconds,
      duration_minutes: durationMinutes,
      name: user.name,
      email: user.email,
    });
    incrementTimeSpent(durationMinutes);
  }
};

